import React, { useEffect, useState } from "react";

import { useForm } from "../useForm";

import Input from "../../controls/Input";
import { classNames } from "primereact/utils";
import { InputNumber } from "primereact/inputnumber";

const initialFValues = {
  original_on_hand: 0,
  inventory_on_hand: 0,
  quantity: 0,
};

export default function QuickScanAddToShippingForm(props) {
  const {
    confirmAction,
    item,
    orderQuantity,
    setOpen,
    currQuantity,
    selling_unit_of_measure,
  } = props;

  const [inProgress, setInProgress] = useState(false);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("quantity" in fieldValues) {
      temp.quantity = null;
      if (fieldValues.quantity < 1) {
        temp.quantity = "Quantity must be more than 0.";
      }

      if (
        fieldValues.quantity >
        parseFloat(item.inventory_on_hand) + parseFloat(fieldValues.quantity)
      ) {
        temp.quantity = "Quantity cannot be greater than inventory on hand.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  const onSubmit = () => {
    if (validate()) {
      setInProgress(true);
      confirmAction(values);
    }
  };

  useEffect(() => {
    setValues({
      product_code: item.product_code,
      product_lot: item.product_lot,
      original_on_hand: parseFloat(item.inventory_on_hand) + parseFloat(currQuantity || 0),
      inventory_on_hand: item.inventory_on_hand,
      quantity: currQuantity,
    });
  }, [currQuantity]);

  return (
    <div className="justify-between">
      <div>
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div className="mt-2">
            <h3 className="text-lg leading-6 font-medium text-gray-700">
              Add:{" "}
              <span className="text-gray-900 font-heavy">
                {item.product_name}
              </span>
            </h3>
            <h3 className="text-md leading-6 font-medium text-gray-700">
              Description:
              <span className="text-gray-900 font-heavy">
                {item.description_en}
              </span>
            </h3>
            <h3 className="text-md leading-6 font-medium text-gray-700">
              Lot:{" "}
              <span className="text-gray-900 font-heavy">
                {item.product_lot}
              </span>
            </h3>
          </div>
        </div>

        {/* here */}
        <div className="pt-2 pb-5 gap-4">
          <div className="bg-white sm:rounded-xl">
            <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <Input
                  label="Inventory on hand"
                  name="inventory_on_hand"
                  onChange={handleInputChange}
                  value={values.inventory_on_hand}
                  labelOn={true}
                  type="text"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                  disabled={true}
                />
                <p className="text-xs text-gray-500 mt-1">
                  Calculated as: inventory_on_hand + quantity
                </p>
              </div>
              <Input
                label="Selling unit"
                name="selling_unit"
                onChange={handleInputChange}
                value={selling_unit_of_measure}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                disabled={true}
              />
              <div>
                <label
                  htmlFor="quantity"
                  className="text-sm block font-medium text-gray-900"
                >
                  quantity
                </label>
                <InputNumber
                  name="quantity"
                  value={values.quantity}
                  onValueChange={(e) => {
                    var newVal = e.target.value;
                    var tempInventoryOnHand = values.original_on_hand;
                    if (newVal > 0) {
                      newVal = parseFloat(newVal);

                      tempInventoryOnHand =
                        newVal > 0
                          ? parseFloat(values.original_on_hand) - newVal
                          : values.original_on_hand;
                    }
                    setValues({
                      ...values,
                      inventory_on_hand: tempInventoryOnHand,
                      quantity: newVal,
                    });
                  }}
                />
                <p
                  className="cursor-pointer text-indigo-600 font-bold"
                  onClick={() => {
                    setValues({
                      ...values,
                      inventory_on_hand:
                        parseFloat(values.original_on_hand) +
                        parseFloat(values.quantity) -
                        parseFloat(orderQuantity),
                      quantity: orderQuantity,
                    });
                  }}
                >
                  Set order quantity
                </p>
              </div>
            </div>
          </div>

          <div className="sm:flex-no-wrap">
            <div className="my-auto flex items-center">
              <button
                onClick={() => onSubmit()}
                className="inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center"
              >
                {inProgress ? (
                  <svg
                    className={classNames(
                      "animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    )}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                ) : (
                  "OK"
                )}
              </button>
              <button
                onClick={() =>
                  setOpen({
                    open: false,
                  })
                }
                className="ml-2 inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 items-center"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
